import * as React from "react"
const SvgComponent = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    xmlSpace="preserve"
    style={{
      shapeRendering: "geometricPrecision",
      textRendering: "geometricPrecision",
      imageRendering: "optimizeQuality",
      fillRule: "evenodd",
      clipRule: "evenodd",
    }}
    viewBox="0 0 20388 19950"
    {...props}
  >
    <defs>
      <style>{".fil0{fill:#000}"}</style>
    </defs>
    <g id="Layer_x0020_1">
      <g id="_1970281372832">
        <path
          d="m8960 15171-4301-4698h8641l-4340 4698zM7009 1513h3981v7964H7009V1513zm7406 7964h-2429V995c0-278-239-517-518-517H6491c-279 0-518 239-518 517v8482H3465c-199 0-359 120-438 279-80 159-40 398 79 517l5455 5974c200 199 518 199 717 0l5456-5974c119-159 159-358 79-517 0-199-199-279-398-279z"
          className="fil0"
        />
        <path
          d="m14057 12105-5097 5575-5097-5575c-199-199-518-199-717-39-199 199-199 517-40 716l5455 5973c200 199 518 199 717 0l5456-5973c199-199 159-517-41-716-119-160-437-160-636 39zM19910 15968c264 0 478 214 478 478 0 263-214 478-478 478s-478-215-478-478c0-264 214-478 478-478zM17402 10991c264 0 478 214 478 478 0 263-214 477-478 477s-478-214-478-477c0-264 214-478 478-478zM16924 995c285 0 517 232 517 518s-232 517-517 517c-286 0-518-231-518-517s232-518 518-518zM2469 4977c286 0 518 232 518 518s-232 518-518 518-517-232-517-518 231-518 517-518zM478 14973c264 0 478 213 478 478 0 263-214 477-478 477S0 15714 0 15451c0-265 214-478 478-478zM4460 17879c286 0 518 232 518 518s-232 518-518 518-518-232-518-518c1-286 232-518 518-518zM1991 1752c0-398 319-757 757-757 398 0 756 319 756 757s-318 756-756 756-757-358-757-756zm2469 0C4460 796 3664 0 2708 0S956 796 956 1752s796 1752 1752 1752 1752-796 1752-1752zM17640 7487c-677 0-1234-558-1234-1235s557-1234 1234-1234 1235 557 1235 1234-517 1235-1235 1235zm0-3505c-1234 0-2229 995-2229 2230 0 1234 995 2230 2229 2230 1235 0 2231-996 2231-2230 39-1235-956-2230-2231-2230zM16406 18915c-279 0-517-240-517-518 0-279 238-518 517-518s518 239 518 518c0 278-239 518-518 518zm0-1991c-836 0-1513 677-1513 1512 0 837 677 1514 1513 1514s1513-677 1513-1514c0-836-677-1512-1513-1512z"
          className="fil0"
        />
      </g>
    </g>
  </svg>
)
export default SvgComponent
